import { IconButton, TrashIcon } from "@picklebet/ui";
import React from "react";
import * as styles from "./RemoveAction.module.scss";

export const RemoveAction = ({ onClick }: { onClick: () => void }) => {
  return (
    <IconButton
      variant="secondary"
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
      className={styles.removeAction}
    >
      <TrashIcon />
    </IconButton>
  );
};
